import React from 'react';

/** ASSETS */
import steamLogoSmall from '../../assets/steam-logo-small.png';
import steamLogoFull from '../../assets/steam-logo-full.png';
import discordLogoSmall from '../../assets/discord-logo-small.png';
import discordLogoFull from '../../assets/discord-logo-full.png';

/** COMPONENTS */
import { Logo } from './styled';

/**
 * Social Logos Component
 * Includes Steam and Discord
 *
 * @param {*} { align, dark, iconOnly, ...otherProps }
 */
const SocialLogos = ({ align, dark, iconOnly, ...otherProps }) => (
  <div
    style={{
      display: 'flex',
      justifyContent: align || 'flex-end',
      ...(otherProps.style || {}),
    }}
  >
    <a
      href="https://steamcommunity.com/groups/TheSouthernCrossUK"
      target="_blank"
      rel="noopener noreferrer"
      style={{ margin: '0 8px' }}
    >
      <Logo
        src={iconOnly ? steamLogoSmall : steamLogoFull}
        alt="Steam Logo"
        iconOnly={iconOnly}
        dark={dark}
      />
    </a>

    <a
      href="https://discord.gg/97J6kyg"
      target="_blank"
      rel="noopener noreferrer"
      style={{ margin: '0 8px' }}
    >
      <Logo
        src={iconOnly ? discordLogoSmall : discordLogoFull}
        alt="Discord Logo"
        iconOnly={iconOnly}
        dark={dark}
      />
    </a>
  </div>
);

export default SocialLogos;
